import classes from "./KnowledgeCheck.module.css"
import KnowledgeCheckIcon from "./KnowledgeCheckIcon";
import {useEffect, useState} from "react";
import Plot from "react-plotly.js";
import {msToTime} from "../../utils/time";

export interface KnowledgeCheckProps {
    knowledge_check_name: string;
    avg_time_ms: number;
    percentage_correct: number;
    percentage_incorrect: number;
}

export default function KnowledgeCheck({knowledge_check_name, avg_time_ms, percentage_correct, percentage_incorrect}: KnowledgeCheckProps) {
    const [avgTime, setAvgTime] = useState<string>("00:00:00");
    const [correct, setCorrect] = useState<number>(0);
    const [incorrect, setIncorrect] = useState<number>(0);
    const [showChart, setShowChart] = useState(false);
    
    useEffect(() => {
        setAvgTime(msToTime(avg_time_ms));
        setCorrect(Math.round(percentage_correct))
        setIncorrect(Math.round(percentage_incorrect))
        const handleChart = () => {
            if (window.innerWidth < 500) {
                setShowChart(false);
            } else {
                setShowChart(true);
            }
        }
        handleChart();
    },[avg_time_ms, percentage_correct, percentage_incorrect]);
    return (
        <div className={classes.knowledgeCheckContainer}>
            <div className={classes.rowContainer} style={{justifyContent: "space-between", gap: "10px"}}>
                <div className={classes.columnContainer} style={{gap: "10px"}}>
                    <p className={classes.knowledgeCheckName}>{knowledge_check_name}</p>
                    <div className={classes.rowContainer} style={{ justifyContent: "space-between"}}>
                        <div className={classes.columnContainer} style={{gap: "3px"}}>
                            <div className={classes.rowContainer} >
                                <p className={classes.percentageNumber} style={{color: "#26BCD7"}}>
                                    {correct}
                                </p>
                                <p className={classes.percentageSmall}>%</p>
                            </div>
                            <p className={classes.text1}>Correct</p>
                        </div>
                        <div className={classes.columnContainer} style={{gap: "3px"}}>
                            <div className={classes.rowContainer}>
                                <p className={classes.percentageNumber} style={{color: "#006E87"}}>
                                    {incorrect}
                                </p>
                                <p className={classes.percentageBig}>%</p>
                            </div>
                            <p className={classes.text1}>Incorrect</p>
                        </div>
                    </div>
                    <p className={classes.text2}>Average Time to Completion</p>
                    <div className={classes.rowContainer} style={{gap: "10px"}}>
                        <KnowledgeCheckIcon/>
                        <div className={classes.columnContainer} style={{gap: "5px"}}>
                            <p className={classes.text1}>Knowledge Checks</p>
                            <p className={classes.averageTimeCompletion}>{avgTime}</p>
                        </div>
                    </div>
                </div>
                {showChart && (
                    <Plot
                        data={[{
                            values: [incorrect, correct],
                            type: 'pie',
                            hole: 0,
                            marker: {
                                colors: ['#006E87', '#26BCD7']
                            },
                            textinfo: 'none',
                            hoverinfo: 'none'
                        }]}
                        layout={{
                            width: 120,
                            height: 120,
                            margin: { l: 0, r: 0, b: 0, t: 0, pad: 0 },
                            showlegend: false,
                            paper_bgcolor: 'rgba(0,0,0,0)',
                        }}
                        config={{ displayModeBar: false }}
                    />
                )}
            </div>
        </div>
    )
}